import { MEDIA } from "@/styles/common";
import { Center, Img } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useNewNavigate } from "@shared/client";
import { DetailMenuBar, GlobalNavBar, ToggleMenu } from "./components";
import { useScrollGnb } from "./hooks";
import { type HeaderProps } from "./types";

interface WrapperProps {
    headerScrollDown: boolean;
}
export const Header = ({ logoUrl, navigation }: HeaderProps) => {
    const { isScrollDown } = useScrollGnb();
    const { isTablet, isMobile } = MEDIA();
    const { onNavigate } = useNewNavigate();

    return (
        <S.Wrapper headerScrollDown={!isTablet && isScrollDown}>
            <Center h="100px" p={isTablet ? "0 20px" : "0 80px"} justifyContent="space-between">
                <Img
                    src={logoUrl}
                    w={isMobile ? "108px" : "180px"}
                    h={isMobile ? "36px" : "60px"}
                    cursor="pointer"
                    onClick={() => {
                        onNavigate({ path: "/home" });
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                />
                {isScrollDown && !isTablet ? (
                    <GlobalNavBar navigation={navigation} />
                ) : (
                    <ToggleMenu>
                        <DetailMenuBar navigation={navigation} />
                    </ToggleMenu>
                )}
            </Center>
        </S.Wrapper>
    );
};

const Wrapper = styled.header<WrapperProps>`
    width: 100%;
    position: fixed;
    z-index: 9997;
    transition: 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    background: ${({ headerScrollDown }) => (headerScrollDown ? "#fff" : "none")};
`;

const S = { Wrapper };
